import './ChartTooltip.scss';

/**
 * Floating tooltip pill shared by the bar/candle/scatter chart components —
 * same look as LineChart's tooltip. Each chart computes its own `style`
 * (position depends on that chart's own padding/geometry) via
 * `tooltipStyleAt` from `useIndexHover`; this just renders the pill.
 */
export default function ChartTooltip({ tooltipRef, style, className = '', children }) {
  return (
    <div ref={tooltipRef} className={`ac-chart-tooltip ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}
